import './sentry'
import Vue from 'vue'
import VueMq from 'vue-mq'
import VueAnalytics from 'vue-analytics'

import App from './App'
import router from './router'
import '@/assets/scss/style.scss'

Vue.config.productionTip = false

if (process.env.VUE_APP_GA_TRACKING_ID) {
  const isKraken = document.cookie.includes('kraken=1')
  const isNetlify = window.location.hostname.includes('netlify.com')

  if (!(isKraken || isNetlify)) {
    Vue.use(VueAnalytics, {
      id: process.env.VUE_APP_GA_TRACKING_ID,
      router
    })
  }
}

Vue.use(VueMq)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

if (process.env.NODE_ENV === 'production') {
  const fcJS = document.createElement('script')

  fcJS.async = true
  fcJS.id = 'freshchat-js-sdk'
  fcJS.src = 'https://wchat.freshchat.com/js/widget.js'
  fcJS.onload = () => {
    window.fcWidget.init({
      token: 'e964927f-fac2-42fb-a1dd-42de29cdfd29',
      host: 'https://wchat.freshchat.com',
      config: {
        headerProperty: {
          backgroundColor: '#486581'
        }
      }
    })
  }

  document.head.appendChild(fcJS)
}
